import { motion } from "framer-motion";
import { COMPANY } from "../../data";

const PHONE = "919823377330";
const MESSAGE = encodeURIComponent(
  "Hi Polycaps Tech Plast, I'd like an enquiry about your caps & closures."
);
const WA_URL = `https://wa.me/${PHONE}?text=${MESSAGE}`;

export const WhatsAppButton = () => (
  <motion.a
    data-testid="whatsapp-button"
    href={WA_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={`Message ${COMPANY.name} on WhatsApp`}
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.06 }}
    whileTap={{ scale: 0.92 }}
    className="group fixed bottom-5 right-5 md:bottom-7 md:right-7 z-[60] flex items-center gap-3 rounded-full bg-[#25D366] pl-4 pr-5 py-3.5 shadow-[0_10px_30px_rgba(37,211,102,0.45)]"
  >
    <span className="absolute inline-flex h-14 w-14 -z-10 rounded-full bg-[#25D366] opacity-60 animate-ping" />
    <svg viewBox="0 0 32 32" width="26" height="26" fill="white" className="shrink-0">
      <path d="M16.003 3.2c-7.06 0-12.79 5.73-12.79 12.79 0 2.254.59 4.457 1.712 6.4L3.2 28.8l6.57-1.717a12.74 12.74 0 006.233 1.62h.005c7.06 0 12.79-5.73 12.79-12.79 0-3.42-1.332-6.635-3.75-9.053A12.7 12.7 0 0016.003 3.2zm0 23.36h-.004a10.57 10.57 0 01-5.39-1.476l-.386-.23-4.003 1.05 1.068-3.9-.252-.4a10.56 10.56 0 01-1.62-5.615c0-5.87 4.777-10.646 10.65-10.646a10.58 10.58 0 017.53 3.12 10.58 10.58 0 013.117 7.53c0 5.872-4.777 10.647-10.65 10.647zm5.84-7.968c-.32-.16-1.894-.935-2.188-1.042-.293-.107-.507-.16-.72.16-.214.32-.826 1.042-1.013 1.256-.187.213-.373.24-.693.08-.32-.16-1.352-.498-2.576-1.59-.952-.85-1.594-1.898-1.78-2.218-.187-.32-.02-.493.14-.653.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.214.053-.4-.027-.56-.08-.16-.72-1.737-.987-2.378-.26-.624-.523-.54-.72-.55l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.094-1.12 2.67 0 1.575 1.147 3.098 1.307 3.312.16.213 2.26 3.45 5.474 4.837.765.33 1.362.527 1.827.674.767.244 1.466.21 2.018.127.616-.092 1.894-.774 2.16-1.522.267-.747.267-1.388.187-1.522-.08-.133-.293-.213-.613-.373z" />
    </svg>
    <span className="text-sm font-semibold text-white hidden sm:block">Chat on WhatsApp</span>
  </motion.a>
);
